import { colorStrings, mediaQueriesBP } from "@bevco/Utilities/variables";
import { actionsStyles as styles } from "@insite/content-library/Widgets/ProductList/ProductListActions";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.addToCartWrapper = {
    ...styles.addToCartWrapper,
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        gap: 5px;
        flex-wrap: nowrap;
    `,
};

styles.addToCartButton = {
    ...styles.addToCartButton,
    css: css`
        flex: 1 1 auto;
        max-height: 40px;
        padding: 0 10px;
    `,
};

styles.quantityOrdered = {
    ...styles.quantityOrdered,
    cssOverrides: {
        formField: css`
            flex: 1 1 auto;
        `,
    },
};
